import { AppIcons } from '@backstage/core-app-api';
import { IconComponent } from '@backstage/core-plugin-api';
import BuildIcon from '@material-ui/icons/Build';
import CloudIcon from '@material-ui/icons/Cloud';
import CodeIcon from '@material-ui/icons/Code';
import FeedbackIcon from '@material-ui/icons/Feedback';
import FlagIcon from '@material-ui/icons/Flag';
import LanguageIcon from '@material-ui/icons/Language';
import TimelineIcon from '@material-ui/icons/Timeline';
import WebIcon from '@material-ui/icons/Web';

// https://github.com/backstage/backstage/blob/master/packages/app-defaults/src/defaults/icons.tsx
export const icons: Partial<AppIcons> & {
  [key in string]: IconComponent;
} = {
  build: BuildIcon,
  cloud: CloudIcon,
  code: CodeIcon,
  feedback: FeedbackIcon,
  flag: FlagIcon,
  language: LanguageIcon,
  timeline: TimelineIcon,
  web: WebIcon,
};
